/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Tags_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Comma-separated values" |
*
* @param {Iconik_Metadata_Tags_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_tags_placeholder = /** @type {((inputs?: Iconik_Metadata_Tags_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Tags_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "de") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Comma-separated values")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comma-separated values")
	return /** @type {LocalizedString} */ ("Comma-separated values")
});